import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaFileInvoiceDollar, FaMinus, FaPlus, FaSave, FaSearch, FaUserFriends } from 'react-icons/fa';
import {TbCalendarUser } from  "react-icons/tb";
import styles from "./reportes.module.css";
import { api } from '../utils/services/api';
import Swal from 'sweetalert2';
import WindowLayout from '../utils/layout/windowsLayout';
import Select from 'react-select';
import { APP_OPTIONS, SERVICE } from '../utils/constants/services';
import { IoMdPrint } from 'react-icons/io';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import {Bar } from "react-chartjs-2";
import { HiDocumentReport  } from "react-icons/hi";
import { downloadPDFFromBase64, isMobileDevice, openPDFInNewWindow } from '../utils/downloadUtils';

export default function Reportes(props) {
    const { windowSize,setMenuActual } = useAuth();
    const [mesSelect, setMesSelect] = useState('');
    const [aniosSelect, setAniosSelect] = useState('');
    const [sucursales, setSucursales] = useState([]);
    const [sucursalSelect, setSucursalSelect] = useState(null);
    const [fecha, setFecha] = useState( new Date().toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'America/Mexico_City'
      }).split('/').reverse().join('-'));
    const [loading, setLoading] = useState(false);
    const [dataGraphicColocatedNumPrestamos, setDataGraphicColocatedNumPrestamos] = useState([]);
    const [dataGraphicColocatedMontoColocado, setDataGraphicColocatedMontoColocado] = useState([]);
    const [dataGraphicColocatedMontoPagado, setDataGraphicColocatedMontoPagado] = useState([]);
    const [dataGraphicOverdueVencido, setDataGraphicOverdueVencido] = useState([]); 
    
    const [show, setShow] = useState(false);
    const [loadingPrint, setLoadingPrint] = useState(false);
    const [loadingPrint2, setLoadingPrint2] = useState(false);

    const optionsGraphicLoansColocated = {
  responsive: true,
  plugins: {
    legend: {
      display: true,
       position: 'right',
       labels: {
              padding: 30,
              color:  "#525457ff",
            }
    },
  },
  scales: {
    x: {
      grid: {
        display: false, // Oculta las líneas de la cuadrícula en el eje X
      },
    },
    y: {
      grid: {
        display: false, // Oculta las líneas de la cuadrícula en el eje Y
      },
    },
  },
};

   const getGraphicLoansColocated = {
         labels: ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO","JULIO","AGOSTO","SEPTIEMBRE","OCTUBRE","NOVIEMBRE","DICIEMBRE"],
        datasets: [
            {
                label: "PRESTAMOS",
                data: dataGraphicColocatedNumPrestamos,
                backgroundColor: "#2385cf",
            },
               {
                label: "COLOCADO",
                data: dataGraphicColocatedMontoColocado,
                backgroundColor: "#4d63cf",
            },
             {
                label: "PAGADO",
                data: dataGraphicColocatedMontoPagado,
                backgroundColor: "#34cadc",
            },
        ],
    };

     const getGraphicLoansOverdue = {
        labels: ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO","JULIO","AGOSTO","SEPTIEMBRE","OCTUBRE","NOVIEMBRE","DICIEMBRE"],
        datasets: [
            {
                label: "VENCIDO",
                data: dataGraphicOverdueVencido,
                backgroundColor: "#c6485d",
            },
             
        ],
    };

 const meses = [
    { value: 1, label: 'Enero' },
    { value: 2, label: 'Febrero' },
    { value: 3, label: 'Marzo' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Mayo' },
    { value: 6, label: 'Junio' },
    { value: 7, label: 'Julio' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Septiembre' },
    { value: 10, label: 'Octubre' },
    { value: 11, label: 'Noviembre' },
    { value: 12, label: 'Diciembre' },
    ];

const generarAniosSelect = () => {
  const aniosActual = new Date().getFullYear();
  const aniosArray = [];

  for (let i = 0; i < 2; i++) {
    const anio = aniosActual - i;
    aniosArray.push({
      value: anio,
      label: anio
    });
  }
  return aniosArray;
};

const anios = generarAniosSelect();

    const selectAnioActual= () => {
     const aniosActual = new Date().getFullYear();
    let findAnioActual = anios.find(a => a.value === aniosActual);
    if (findAnioActual) {
        setAniosSelect(findAnioActual);
    }
};


  
    const handleUpdate = () => {
        let mes = 0,anio = 0;
        if(mesSelect!=null){
            if(mesSelect.value != undefined){
                mes=mesSelect.value;
            }
        }
        console.log(mes)

        if(aniosSelect!=null){
            if(aniosSelect.value != undefined){
                anio=aniosSelect.value;
            }
        }

        if (sucursalSelect != null) {
            setLoading(true);

            api(SERVICE.getDataGraphicLoansColocated + `?year=${anio}&month=${mes}&centralOfficeId=${sucursalSelect.value}`)
                .then((data) => {
                    let listInfo = [],listInfoMonto=[],listInfoMontoPagado=[];
                    if (data.data.data) {
                        const info = data.data.data;
                        if(info.length!=0){
                            for (let i = 1; i <= 12; i++) {
                             let mesInfo = info.filter(f => f.monthStartDate == i);
                                if(mesInfo.length!=0){
                                    const totalQtyLoans = mesInfo.reduce((acumulador, objetoActual) => {
                                                          return acumulador + objetoActual.qtyLoans;
                                                         }, 0);

                                    const totalAmountLoans = mesInfo.reduce((acumulador, objetoActual) => {
                                                          return acumulador + objetoActual.amountColocated;
                                                         }, 0);

                                    const totalAmountPaymentLoans = mesInfo.reduce((acumulador, objetoActual) => {
                                                          return acumulador + objetoActual.amountPayment;
                                                         }, 0);
                                   
                                    listInfo.push(totalQtyLoans);  
                                    listInfoMonto.push(totalAmountLoans);  
                                    listInfoMontoPagado.push(totalAmountPaymentLoans);  
                                }else{
                                    listInfo.push(0);   
                                    listInfoMonto.push(0);  
                                    listInfoMontoPagado.push(0);        
                                }
                                
                            }
                           setDataGraphicColocatedNumPrestamos(listInfo);
                           setDataGraphicColocatedMontoColocado(listInfoMonto);
                           setDataGraphicColocatedMontoPagado(listInfoMontoPagado);
                        }else{
                            setDataGraphicColocatedNumPrestamos([]);
                            setDataGraphicColocatedMontoColocado([]);
                            setDataGraphicColocatedMontoPagado([]);
                        }
                    }
                    else {
                        setDataGraphicColocatedNumPrestamos([]);
                        setDataGraphicColocatedMontoColocado([]);
                        setDataGraphicColocatedMontoPagado([]);
                    }

                  
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
        else {
            setDataGraphicColocatedNumPrestamos([]);
            setDataGraphicColocatedMontoColocado([]);
            setDataGraphicColocatedMontoPagado([]);
        }
    }

     const handleDownloadGraphicColocated= () => {
        let mes = 0,anio = 0;
        if(mesSelect!=null){
            if(mesSelect.value != undefined){
                mes=mesSelect.value;
            }
        }

        if(aniosSelect!=null){
            if(aniosSelect.value != undefined){
                anio=aniosSelect.value;
            }
        }

        if (sucursalSelect != null) {
            setLoading(true);

            api(SERVICE.getReportPDFLoansColocated + `?year=${anio}&month=${mes}&centralOfficeId=${sucursalSelect.value}`)
                .then((data) => {
                    if (data.data.data) {
                       const info = data.data.data;
                       const mesFound = meses.find(item => item.value === mes);
                        const mesName =  mesFound.label;

                        const fileName = "Reporte_Colocacion_" + mesName +"_"+ anio+ ".pdf";
                                               
                        const success = downloadPDFFromBase64(info, fileName);
                                               
                        if (!success && isMobileDevice()) {
                                openPDFInNewWindow(info);
                        }
                    }
                   

                  
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
       
    }

     const handleDownloadClientesPorSemana= () => {
        let mes = 0,anio = 0;
        if(mesSelect!=null){
            if(mesSelect.value != undefined){
                mes=mesSelect.value;
            }
        }

        if(aniosSelect!=null){
            if(aniosSelect.value != undefined){
                anio=aniosSelect.value;
            }
        }

        if (sucursalSelect != null) {
            setLoading(true);

            api(SERVICE.getReportPDFClientsByWeek + `?year=${anio}&month=${mes}&centralOfficeId=${sucursalSelect.value}`)
                .then((data) => {
                    if (data.data.data) {
                       const info = data.data.data;
                       const mesFound = meses.find(item => item.value === mes);
                        const mesName =  mesFound.label;

                        const fileName = "Reporte_ClientesPorSemana_" + mesName +"_"+ anio+ ".pdf";
                                               
                        const success = downloadPDFFromBase64(info, fileName);
                                               
                        if (!success && isMobileDevice()) {
                                openPDFInNewWindow(info);
                        }
                    }
                   

                  
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
       
    }

       const handleDownloadGraphicOverdue= () => {
        let mes = 0,anio = 0;
        if(mesSelect!=null){
            if(mesSelect.value != undefined){
                mes=mesSelect.value;
            }
        }

        if(aniosSelect!=null){
            if(aniosSelect.value != undefined){
                anio=aniosSelect.value;
            }
        }

        if (sucursalSelect != null) {
            setLoading(true);

            api(SERVICE.getReportPDFLoansOverdue + `?year=${anio}&month=${mes}&centralOfficeId=${sucursalSelect.value}`)
                .then((data) => {
                    if (data.data.data) {
                       const info = data.data.data;
                       const mesFound = meses.find(item => item.value === mes);
                        const mesName =  mesFound.label;

                        const fileName = "Reporte_Vencidos_" + mesName +"_"+ anio+ ".pdf";
                                               
                        const success = downloadPDFFromBase64(info, fileName);
                                               
                        if (!success && isMobileDevice()) {
                                openPDFInNewWindow(info);
                        }
                    }
                   

                  
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
       
    }

  const handleUpdateVencidos = () => {
        let mes = 0,anio = 0;
        if(mesSelect!=null){
            if(mesSelect.value != undefined){
                mes=mesSelect.value;
            }
        }
        console.log(mes)

        if(aniosSelect!=null){
            if(aniosSelect.value != undefined){
                anio=aniosSelect.value;
            }
        }

        if (sucursalSelect != null) {
            setLoading(true);

            api(SERVICE.getDataGraphicLoansOverdue + `?year=${anio}&month=${mes}&centralOfficeId=${sucursalSelect.value}`)
                .then((data) => {
                    if (data.data.data) {
                        const info = data.data.data;
                        if(info.length!=0){
                            let listInfoVencido = [];
                            for (let i = 1; i <= 12; i++) {
                             let mesInfo = info.filter(f => f.month == i);
                                if(mesInfo.length!=0){
                                   const totalDeudaMes =  mesInfo.reduce((acumulador, objetoActual) => {
                                                          return acumulador + objetoActual.deuda;
                                                         }, 0);
                                  listInfoVencido.push(totalDeudaMes);
                                }else{
                                    listInfoVencido.push(0);   
                                }
                            }
                         setDataGraphicOverdueVencido(listInfoVencido);

                        }else{
                             setDataGraphicOverdueVencido([]);
                        }
                    }
                    else {
                            setDataGraphicOverdueVencido([]);
                    }

                  
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
        else {
             setDataGraphicOverdueVencido([]);
        }
    }

    const handleGetSucursales = () => {
        api(SERVICE.getOfices)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });

                    }
                }
                setSucursales(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    useEffect(() => {
        handleGetSucursales();
         selectAnioActual();
    }, [])
    useEffect(() => {
        handleUpdate();
        handleUpdateVencidos();
    }, [sucursalSelect,aniosSelect,mesSelect])
    return (
        <>
            <WindowLayout
                title="Reportes"
                route={["Inicio","Reportes"]}
                actions={[() => setMenuActual("homeMenu")]}
                icon={<FaFileInvoiceDollar />}
            >
                <div className='paperContainer'>
                    <div style={{ display: "flex", justifyContent: "left" }}>
                        <div className={styles.itemForm} style={{ width: "25%", zIndex: 4 }}>
                            <label class="form-label">Sucursal: </label>
                            <Select isClearable={true} options={sucursales} class="form-control" placeholder="Seleccione..." value={sucursalSelect} onChange={(e) => setSucursalSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "12.5%", zIndex: 3 }}>
                            <label class="form-label">Año </label>
                             <Select isClearable options={anios} class="form-control" value={aniosSelect} onChange={(e) => setAniosSelect(e)} />
                        </div>
                        <div class={styles.itemForm} style={{ width: "12.5%",zIndex: 2  }}>
                            <label class="form-label">Mes </label>
                             <Select isClearable options={meses} class="form-control" value={mesSelect} onChange={(e) => setMesSelect(e)} />
                        </div>
            
                    </div>
                    <div className={styles.conteMain}>
                        {
                            loading ?

                                <div className={styles.corteNoData}>
                                    <h5>Cargando...</h5>&nbsp;&nbsp;&nbsp;
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                :
                                   
                                        <>

                                            <div style={{ width: "40%", display: !loading && sucursalSelect!=null ? "" : "none" }}>
                                                  
                                                   <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                             
                                                        <button  className={`${styles.DownloadBtn} btn`}  title="Descargar Cartera Colocada" onClick={handleDownloadClientesPorSemana}>
                                                            <HiDocumentReport /> Cartera Colocada
                                                        </button>

                                                        <button  className={`${styles.DownloadBtn} btn`}  title="Descargar Clientes por Semana" onClick={handleDownloadClientesPorSemana}>
                                                            <TbCalendarUser  />  Clientes por Semana
                                                        </button>
                                                    </div>
                                                 <div  className={styles.BackgroundGraphic} style={{ flex: 1, margin: "10px 0px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px" }}>
                                                        <h3 style={{ textAlign: "center",color:"#888d95ff" }}> CARTERA COLOCADA </h3>
                                                        <Bar data={getGraphicLoansColocated} options={optionsGraphicLoansColocated}/>
                                                  </div>
                                                  
                                            </div>
                                           <div style={{ width: "40%",display: !loading && sucursalSelect!=null ? "" : "none" }}>
                                                  
                                                   <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                                        <button className={`${styles.DownloadBtn} btn`}  title="Descargar Cartera Vencida" onClick={handleDownloadGraphicOverdue}>
                                                            <HiDocumentReport /> Cartera Vencida
                                                        </button>
                                                    </div>
                                                 <div  className={styles.BackgroundGraphic} style={{ flex: 1, margin: "10px 0px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px" }}>
                                                        <h3 style={{ textAlign: "center",color:"#888d95ff" }}> CARTERA VENCIDA </h3>
                                                        <Bar data={getGraphicLoansOverdue} options={optionsGraphicLoansColocated}/>
                                                  </div>
                                                  
                                            </div>

                                        </>
                        }

                    </div>



                </div>
            </WindowLayout>
          
        </>
    );
} 